import React, { Fragment, useEffect, useState, useContext } from "react";
import { Button, Box, Container, Grid, Typography } from "@material-ui/core";
import { Link, useLocation, useSearchParams } from "react-router-dom";
import { auth } from "../firebase";
import { signInWithEmailAndPassword, signOut } from "firebase/auth";
import { AuthContext } from "../auth/AuthContext";
import { useNavigate } from "react-router-dom";
import { emailValid } from "../lib/validation";
import ButtonLoader from "../components/ButtonLoader";
import { Environment } from "../utils/environments";
import useScript from "../hooks/useScript";
import { httpPost } from "../lib/apiClients";
import ToastModal from "../components/ToastModal";
import LoaderComponent from "../components/LoaderComponent";
import SectionHeader from "../components/SectionHeader";
import { UserDataContext } from "../context/UserDataContext";
import { ThemeContext } from "../context/ThemeContext";

function Login() {
  const navigate = useNavigate();
  const { currentUser } = useContext(AuthContext);
  const [email, setEmail] = useState("");
  const { fetchUserData, setUserData, setCouponData } =
    useContext(UserDataContext);
  const { clearThemeContext } = useContext(ThemeContext);
  const [emailError, setEmailError] = useState<boolean | string>(false);
  const [loginError, setLoginError] = useState<boolean>(false);
  const [password, setPassword] = useState("");
  const { state } = useLocation();
  const [loading, setLoading] = useState<boolean>(false);
  const siteKey = Environment.getRecaptchaKey();
  const [searchParams, setSearchParams] = useSearchParams();
  const [displayToast, setDisplayToast] = useState<boolean>(false);
  const signupSuccess = searchParams.get("signup")
    ? searchParams.get("signup")
    : "";
  const loadrecaptcha = useScript(
    `https://www.google.com/recaptcha/api.js?render=${siteKey}`,
    {
      removeOnUnmount: true,
    }
  );
  useEffect(() => {
    document.title = "ログイン | じぶん専用IT相談室";
    if (currentUser === undefined) {
      return;
    }
    if (signupSuccess == "success") {
      if (currentUser) {
        const signout = signOut(auth);
        signout.then(() => {
          console.log("signout");
        });
      }
      setDisplayToast(true);
    }
    if (currentUser && signupSuccess != "success") {
      navigate({
        pathname: "/",
      });
    } else {
      setUserData(null);
      clearThemeContext();
    }
    // if (!state && signupSuccess != "success") {
    //   navigate({
    //     pathname: "/",
    //   });
    // }
    return () => {
      var captchaLogo = document.querySelectorAll(".grecaptcha-badge");
      captchaLogo.forEach((logo) => logo.parentElement?.remove());
    };
  }, [currentUser]);

  /**
   *
   * handles User Login
   */
  async function handleLogin(e) {
    e.preventDefault();
    if (loading) {
      return;
    }
    setLoading(true);

    setEmailError(false);
    setLoginError(false);
    if (!emailValid(email)) {
      if (email.length > 319) {
        setEmailError("メールアドレスは、319文字以内で入力してください");
      } else {
        setEmailError("メールアドレス形式で入力してください");
      }
      setLoading(false);
      return;
    }
    // @ts-ignore
    window.grecaptcha.ready(async () => {
      // @ts-ignore
      window.grecaptcha
        .execute(siteKey, { action: "submit" })
        .then(async (token) => {
          if (Environment.getBuildType() != "prod") {
            console.log(token);
          }
          try {
            await httpPost(
              {
                pathName: "login",
                bodyParams: {
                  recaptchaToken: token,
                },
              },
              false
            ).then((response) => {
              if (response.status == 200) {
                loginUser();
                setCouponData(null);
                fetchUserData();
              }
            });
          } catch (error) {
            if (Environment.getBuildType() != "prod") {
              console.log(error);
            }
            setLoginError(true);
            setLoading(false);
          }
        });
    });
  }
  function closeToast() {
    setDisplayToast(false);
    window.location.href = "/login";
  }
  async function loginUser() {
    try {
      await signInWithEmailAndPassword(auth, email, password);
      navigate({
        pathname: state ? state.from : "/",
        search: state ? state.search : "",
      });
    } catch (error) {
      if (Environment.getBuildType() != "prod") {
        console.log(error.message);
      }
      setLoginError(true);
    } finally {
      setLoading(false);
    }
  }
  return (
    <Fragment>
      {currentUser === null ? (
        <Box component={"section"} className="section bg-dots">
          <Container className="container" style={{ marginBottom: "50px" }}>
            <SectionHeader currentPage={"ログイン"} preHeading={"Login"} />
            <Container className="container">
              <Box className="signup-form">
                <form>
                  <Grid
                    container
                    spacing={2}
                    className="signup-group"
                    alignItems="center"
                    style={{ marginBottom: "20px" }}
                  >
                    <Grid item md={3} sm={3} xs={12}>
                      <label>メールアドレス</label>
                    </Grid>
                    <Grid item md={6} sm={12} xs={12}>
                      <input
                        type="text"
                        name="email"
                        placeholder="メールアドレス"
                        className={
                          emailError
                            ? "input-field invalid-input"
                            : "input-field"
                        }
                        value={email}
                        onChange={(
                          event: React.ChangeEvent<HTMLInputElement>
                        ) => {
                          setEmail(event.target.value.trim());
                        }}
                      />
                      {emailError && (
                        <Typography className="error-message">
                          {emailError}
                        </Typography>
                      )}
                    </Grid>
                  </Grid>
                  <Grid
                    container
                    className="signup-group"
                    spacing={2}
                    alignItems="center"
                    style={{ marginBottom: "20px" }}
                  >
                    <Grid item md={3} sm={3} xs={12}>
                      <label>パスワード</label>
                    </Grid>
                    <Grid item md={6} sm={12} xs={12}>
                      <input
                        name="password"
                        placeholder="パスワード"
                        className="input-field"
                        type="password"
                        value={password}
                        onChange={(
                          event: React.ChangeEvent<HTMLInputElement>
                        ) => {
                          setPassword(event.target.value.trim());
                        }}
                      />
                    </Grid>
                  </Grid>
                  <Grid container justifyContent={"center"}>
                    <Grid
                      item
                      md={4}
                      style={{ margin: "30px 0", textAlign: "center" }}
                    >
                      {loading && <div className="button-overlay"></div>}
                      <button
                        className="classification-btn"
                        onClick={(e) => handleLogin(e)}
                        disabled={email == "" || password.length < 1 || loading}
                      >
                        {loading ? <ButtonLoader /> : "ログイン"}
                      </button>
                      {loginError && (
                        <Typography className="error-message">
                          ログインに失敗しました
                        </Typography>
                      )}
                    </Grid>
                  </Grid>
                </form>
                <Typography style={{ textAlign: "center" }}>
                  パスワードを忘れた方は{" "}
                  <Link
                    to="/password-reset-request"
                    style={{
                      color: "#2683c3",
                      borderBottom: "1px solid",
                    }}
                  >
                    こちら
                  </Link>
                </Typography>
                {/* <Typography style={{ marginTop: "1rem", textAlign: "center" }}>
                  アカウントをお持ちでない方は、
                  <Link
                    to="/signup"
                    style={{
                      color: "#2683c3",
                      borderBottom: "1px solid",
                    }}
                  >
                    こちら
                  </Link>
                  から会員登録をお願いいたします。
                </Typography> */}
              </Box>
            </Container>
          </Container>
        </Box>
      ) : (
        <LoaderComponent />
      )}

      {displayToast && (
        <ToastModal
          errorModal={displayToast}
          setErrorModal={closeToast}
          message={
            "会員登録ありがとうございました。\nログインより本サービスを是非ご利用ください。"
          }
        />
      )}
    </Fragment>
  );
}

export default Login;
